import type { ModalIdentifier, OpenXhrModalOptions, SfJQuery } from '@app/types'
import type { InitializedXhrModals, XhrModalHandlerInterface } from '../types'

import $ from 'jquery'

import BaseModalHandler from './base-modal-handler'
import SFetch from '@app/utils/sfetch'

export default class XhrModalHandler
  extends BaseModalHandler
  implements XhrModalHandlerInterface
{
  private initializedModals: InitializedXhrModals

  constructor() {
    super()
    this.initializedModals = {}
  }

  async open(
    event: Event,
    modalIdentifier: string,
    url: string,
    options: OpenXhrModalOptions
  ): Promise<void> {
    event.preventDefault()
    event.stopPropagation()

    const fetchOptions: {
      method?: 'GET' | 'POST'
    } = {}

    if (options['method']) {
      fetchOptions.method = options['method']
    }

    try {
      const response = await SFetch.html(url, fetchOptions)

      if (options && options['close_existing_modal']) {
        this.close(options['close_existing_modal'])
      }

      if (!response) {
        return
      }

      const $modalHtml = $(response) as SfJQuery

      this.close(modalIdentifier)

      const $container = $('<div></div>').append($modalHtml)
      $('body').append($container)
      this.initializedModals[modalIdentifier] = $container

      if ($modalHtml.sfModal && $modalHtml.initializeDom) {
        $modalHtml.sfModal()
        $modalHtml.initializeDom()
      }

      this._emitModalOpened(modalIdentifier as ModalIdentifier)
    } catch (error) {
      console.log(error)
    }
  }

  close(modalIdentifier: string): void {
    if (this.initializedModals[modalIdentifier]) {
      this.initializedModals[modalIdentifier].remove()
      delete this.initializedModals[modalIdentifier]
    }
  }

  hasVisibleModals(): boolean {
    return Object.values(this.initializedModals).some(($container) =>
      $container.find('.sf-modal').is(':visible')
    )
  }

  cleanup(): void {
    Object.keys(this.initializedModals).forEach((key) => {
      const modal = this.initializedModals[key]
      modal.remove()
    })
    this.initializedModals = {}
  }
}
